/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/SpecialMenuItem', 'model/UserFunctionalityAccessReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./SpecialMenuItem'), require('./UserFunctionalityAccessReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SessionInformation = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.SpecialMenuItem, root.ForStractionServiceApi.UserFunctionalityAccessReport);
  }
}(this, function(ApiClient, SpecialMenuItem, UserFunctionalityAccessReport) {
  'use strict';




  /**
   * The SessionInformation model module.
   * @module model/SessionInformation
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>SessionInformation</code>.
   * @alias module:model/SessionInformation
   * @class
   */
  var exports = function() {
    var _this = this;































































  };

  /**
   * Constructs a <code>SessionInformation</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SessionInformation} obj Optional instance to populate.
   * @return {module:model/SessionInformation} The populated <code>SessionInformation</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('UserID')) {
        obj['UserID'] = ApiClient.convertToType(data['UserID'], 'Integer');
      }
      if (data.hasOwnProperty('Email')) {
        obj['Email'] = ApiClient.convertToType(data['Email'], 'String');
      }
      if (data.hasOwnProperty('UserName')) {
        obj['UserName'] = ApiClient.convertToType(data['UserName'], 'String');
      }
      if (data.hasOwnProperty('CurrentCompanyID')) {
        obj['CurrentCompanyID'] = ApiClient.convertToType(data['CurrentCompanyID'], 'Integer');
      }
      if (data.hasOwnProperty('CurrentCompanyName')) {
        obj['CurrentCompanyName'] = ApiClient.convertToType(data['CurrentCompanyName'], 'String');
      }
      if (data.hasOwnProperty('DefaultLoginCompanyID')) {
        obj['DefaultLoginCompanyID'] = ApiClient.convertToType(data['DefaultLoginCompanyID'], 'Integer');
      }
      if (data.hasOwnProperty('Language')) {
        obj['Language'] = ApiClient.convertToType(data['Language'], 'String');
      }
      if (data.hasOwnProperty('CurrentLanguageID')) {
        obj['CurrentLanguageID'] = ApiClient.convertToType(data['CurrentLanguageID'], 'Integer');
      }
      if (data.hasOwnProperty('UserFunctionID')) {
        obj['UserFunctionID'] = ApiClient.convertToType(data['UserFunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('ServiceVersion')) {
        obj['ServiceVersion'] = ApiClient.convertToType(data['ServiceVersion'], 'String');
      }
      if (data.hasOwnProperty('IsUserAdministrator')) {
        obj['IsUserAdministrator'] = ApiClient.convertToType(data['IsUserAdministrator'], 'Boolean');
      }
      if (data.hasOwnProperty('IsUser4SAdministrator')) {
        obj['IsUser4SAdministrator'] = ApiClient.convertToType(data['IsUser4SAdministrator'], 'Boolean');
      }
      if (data.hasOwnProperty('FunctionalityAccesses')) {
        obj['FunctionalityAccesses'] = ApiClient.convertToType(data['FunctionalityAccesses'], [UserFunctionalityAccessReport]);
      }
      if (data.hasOwnProperty('FunctionalityAddOns')) {
        obj['FunctionalityAddOns'] = ApiClient.convertToType(data['FunctionalityAddOns'], ['Integer']);
      }
      if (data.hasOwnProperty('HomePageID')) {
        obj['HomePageID'] = ApiClient.convertToType(data['HomePageID'], 'Integer');
      }
      if (data.hasOwnProperty('OverrideLogoURI')) {
        obj['OverrideLogoURI'] = ApiClient.convertToType(data['OverrideLogoURI'], 'String');
      }
      if (data.hasOwnProperty('OverrideTopColorHex')) {
        obj['OverrideTopColorHex'] = ApiClient.convertToType(data['OverrideTopColorHex'], 'String');
      }
      if (data.hasOwnProperty('CompanyTemplateTypeID')) {
        obj['CompanyTemplateTypeID'] = ApiClient.convertToType(data['CompanyTemplateTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('OriginalSessionFromUserID')) {
        obj['OriginalSessionFromUserID'] = ApiClient.convertToType(data['OriginalSessionFromUserID'], 'Integer');
      }
      if (data.hasOwnProperty('HasPendingMicrosoftTeamsTenant')) {
        obj['HasPendingMicrosoftTeamsTenant'] = ApiClient.convertToType(data['HasPendingMicrosoftTeamsTenant'], 'Boolean');
      }
      if (data.hasOwnProperty('HasLinkedMicrosoftTeamsTenant')) {
        obj['HasLinkedMicrosoftTeamsTenant'] = ApiClient.convertToType(data['HasLinkedMicrosoftTeamsTenant'], 'Boolean');
      }
      if (data.hasOwnProperty('HasPartnerPanel')) {
        obj['HasPartnerPanel'] = ApiClient.convertToType(data['HasPartnerPanel'], 'Boolean');
      }
      if (data.hasOwnProperty('PartnerCompanyName')) {
        obj['PartnerCompanyName'] = ApiClient.convertToType(data['PartnerCompanyName'], 'String');
      }
      if (data.hasOwnProperty('PartnerCompanyID')) {
        obj['PartnerCompanyID'] = ApiClient.convertToType(data['PartnerCompanyID'], 'Integer');
      }
      if (data.hasOwnProperty('IsPartnerCompanyAdministrator')) {
        obj['IsPartnerCompanyAdministrator'] = ApiClient.convertToType(data['IsPartnerCompanyAdministrator'], 'Boolean');
      }
      if (data.hasOwnProperty('SpecialMenuItems')) {
        obj['SpecialMenuItems'] = ApiClient.convertToType(data['SpecialMenuItems'], [SpecialMenuItem]);
      }
      if (data.hasOwnProperty('IsAdvisor')) {
        obj['IsAdvisor'] = ApiClient.convertToType(data['IsAdvisor'], 'Boolean');
      }
      if (data.hasOwnProperty('AdvisorID')) {
        obj['AdvisorID'] = ApiClient.convertToType(data['AdvisorID'], 'Integer');
      }
      if (data.hasOwnProperty('AdvisorName')) {
        obj['AdvisorName'] = ApiClient.convertToType(data['AdvisorName'], 'String');
      }
      if (data.hasOwnProperty('AdvisorLogoURI')) {
        obj['AdvisorLogoURI'] = ApiClient.convertToType(data['AdvisorLogoURI'], 'String');
      }
      if (data.hasOwnProperty('AdvisorPromotionalText')) {
        obj['AdvisorPromotionalText'] = ApiClient.convertToType(data['AdvisorPromotionalText'], 'String');
      }
      if (data.hasOwnProperty('AdvisorPromotionalURI')) {
        obj['AdvisorPromotionalURI'] = ApiClient.convertToType(data['AdvisorPromotionalURI'], 'String');
      }
      if (data.hasOwnProperty('CashflowForecastEnabled')) {
        obj['CashflowForecastEnabled'] = ApiClient.convertToType(data['CashflowForecastEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('Is4SCompany')) {
        obj['Is4SCompany'] = ApiClient.convertToType(data['Is4SCompany'], 'Boolean');
      }
      if (data.hasOwnProperty('ProductPackageID')) {
        obj['ProductPackageID'] = ApiClient.convertToType(data['ProductPackageID'], 'Integer');
      }
      if (data.hasOwnProperty('HasTemporaryAlertAccess')) {
        obj['HasTemporaryAlertAccess'] = ApiClient.convertToType(data['HasTemporaryAlertAccess'], 'Boolean');
      }
      if (data.hasOwnProperty('HasTemporaryWorkshopAccess')) {
        obj['HasTemporaryWorkshopAccess'] = ApiClient.convertToType(data['HasTemporaryWorkshopAccess'], 'Boolean');
      }
      if (data.hasOwnProperty('StrategyOnboardingDone')) {
        obj['StrategyOnboardingDone'] = ApiClient.convertToType(data['StrategyOnboardingDone'], 'Boolean');
      }
      if (data.hasOwnProperty('StrategyExecutionTypeID')) {
        obj['StrategyExecutionTypeID'] = ApiClient.convertToType(data['StrategyExecutionTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategyPublishingLevelID')) {
        obj['StrategyPublishingLevelID'] = ApiClient.convertToType(data['StrategyPublishingLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategyAllowNotAlignedBreakthrough')) {
        obj['StrategyAllowNotAlignedBreakthrough'] = ApiClient.convertToType(data['StrategyAllowNotAlignedBreakthrough'], 'Boolean');
      }
      if (data.hasOwnProperty('StrategyAllowUserInviteTypeID')) {
        obj['StrategyAllowUserInviteTypeID'] = ApiClient.convertToType(data['StrategyAllowUserInviteTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('PublicPagesEnabled')) {
        obj['PublicPagesEnabled'] = ApiClient.convertToType(data['PublicPagesEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('IsPublicPageUser')) {
        obj['IsPublicPageUser'] = ApiClient.convertToType(data['IsPublicPageUser'], 'Boolean');
      }
      if (data.hasOwnProperty('PublicPageID')) {
        obj['PublicPageID'] = ApiClient.convertToType(data['PublicPageID'], 'Integer');
      }
      if (data.hasOwnProperty('PublicPageCreatedByUserID')) {
        obj['PublicPageCreatedByUserID'] = ApiClient.convertToType(data['PublicPageCreatedByUserID'], 'Integer');
      }
      if (data.hasOwnProperty('IsStrategyFacilitator')) {
        obj['IsStrategyFacilitator'] = ApiClient.convertToType(data['IsStrategyFacilitator'], 'Boolean');
      }
      if (data.hasOwnProperty('CustomerGeneralSatisfaction')) {
        obj['CustomerGeneralSatisfaction'] = ApiClient.convertToType(data['CustomerGeneralSatisfaction'], 'Boolean');
      }
      if (data.hasOwnProperty('UserRoleBillingUserTypeID')) {
        obj['UserRoleBillingUserTypeID'] = ApiClient.convertToType(data['UserRoleBillingUserTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('CanUserAddStrategy')) {
        obj['CanUserAddStrategy'] = ApiClient.convertToType(data['CanUserAddStrategy'], 'Boolean');
      }
      if (data.hasOwnProperty('CompanyHasInitiatives')) {
        obj['CompanyHasInitiatives'] = ApiClient.convertToType(data['CompanyHasInitiatives'], 'Boolean');
      }
      if (data.hasOwnProperty('QuickStartID')) {
        obj['QuickStartID'] = ApiClient.convertToType(data['QuickStartID'], 'Integer');
      }
      if (data.hasOwnProperty('QuickStartEndDate')) {
        obj['QuickStartEndDate'] = ApiClient.convertToType(data['QuickStartEndDate'], 'Date');
      }
      if (data.hasOwnProperty('HasMobileToken')) {
        obj['HasMobileToken'] = ApiClient.convertToType(data['HasMobileToken'], 'Boolean');
      }
      if (data.hasOwnProperty('IsTrialUnknownUser')) {
        obj['IsTrialUnknownUser'] = ApiClient.convertToType(data['IsTrialUnknownUser'], 'Boolean');
      }
      if (data.hasOwnProperty('InitialStartingPoint1')) {
        obj['InitialStartingPoint1'] = ApiClient.convertToType(data['InitialStartingPoint1'], 'Integer');
      }
      if (data.hasOwnProperty('InitialStartingPoint2')) {
        obj['InitialStartingPoint2'] = ApiClient.convertToType(data['InitialStartingPoint2'], 'Integer');
      }
      if (data.hasOwnProperty('WorkshopLanguageCode')) {
        obj['WorkshopLanguageCode'] = ApiClient.convertToType(data['WorkshopLanguageCode'], 'String');
      }
      if (data.hasOwnProperty('IsExternalUser')) {
        obj['IsExternalUser'] = ApiClient.convertToType(data['IsExternalUser'], 'Boolean');
      }
      if (data.hasOwnProperty('UseUserRoleBasedBilling')) {
        obj['UseUserRoleBasedBilling'] = ApiClient.convertToType(data['UseUserRoleBasedBilling'], 'Boolean');
      }
      if (data.hasOwnProperty('AllowCustomTaspaExporting')) {
        obj['AllowCustomTaspaExporting'] = ApiClient.convertToType(data['AllowCustomTaspaExporting'], 'Boolean');
      }
      if (data.hasOwnProperty('DisableWhereby')) {
        obj['DisableWhereby'] = ApiClient.convertToType(data['DisableWhereby'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} UserID
   * @default 0
   */
  exports.prototype['UserID'] = 0;
  /**
   * @member {String} Email
   * @default ''
   */
  exports.prototype['Email'] = '';
  /**
   * @member {String} UserName
   * @default ''
   */
  exports.prototype['UserName'] = '';
  /**
   * @member {Integer} CurrentCompanyID
   * @default 0
   */
  exports.prototype['CurrentCompanyID'] = 0;
  /**
   * @member {String} CurrentCompanyName
   * @default ''
   */
  exports.prototype['CurrentCompanyName'] = '';
  /**
   * @member {Integer} DefaultLoginCompanyID
   * @default 0
   */
  exports.prototype['DefaultLoginCompanyID'] = 0;
  /**
   * @member {String} Language
   * @default ''
   */
  exports.prototype['Language'] = '';
  /**
   * @member {Integer} CurrentLanguageID
   * @default 0
   */
  exports.prototype['CurrentLanguageID'] = 0;
  /**
   * @member {Integer} UserFunctionID
   * @default 0
   */
  exports.prototype['UserFunctionID'] = 0;
  /**
   * @member {String} ServiceVersion
   * @default ''
   */
  exports.prototype['ServiceVersion'] = '';
  /**
   * @member {Boolean} IsUserAdministrator
   * @default false
   */
  exports.prototype['IsUserAdministrator'] = false;
  /**
   * @member {Boolean} IsUser4SAdministrator
   * @default false
   */
  exports.prototype['IsUser4SAdministrator'] = false;
  /**
   * @member {Array.<module:model/UserFunctionalityAccessReport>} FunctionalityAccesses
   */
  exports.prototype['FunctionalityAccesses'] = undefined;
  /**
   * @member {Array.<Integer>} FunctionalityAddOns
   */
  exports.prototype['FunctionalityAddOns'] = undefined;
  /**
   * @member {Integer} HomePageID
   */
  exports.prototype['HomePageID'] = undefined;
  /**
   * @member {String} OverrideLogoURI
   * @default ''
   */
  exports.prototype['OverrideLogoURI'] = '';
  /**
   * @member {String} OverrideTopColorHex
   * @default ''
   */
  exports.prototype['OverrideTopColorHex'] = '';
  /**
   * @member {Integer} CompanyTemplateTypeID
   * @default 0
   */
  exports.prototype['CompanyTemplateTypeID'] = 0;
  /**
   * @member {Integer} OriginalSessionFromUserID
   * @default 0
   */
  exports.prototype['OriginalSessionFromUserID'] = 0;
  /**
   * @member {Boolean} HasPendingMicrosoftTeamsTenant
   * @default false
   */
  exports.prototype['HasPendingMicrosoftTeamsTenant'] = false;
  /**
   * @member {Boolean} HasLinkedMicrosoftTeamsTenant
   * @default false
   */
  exports.prototype['HasLinkedMicrosoftTeamsTenant'] = false;
  /**
   * @member {Boolean} HasPartnerPanel
   * @default false
   */
  exports.prototype['HasPartnerPanel'] = false;
  /**
   * @member {String} PartnerCompanyName
   * @default ''
   */
  exports.prototype['PartnerCompanyName'] = '';
  /**
   * @member {Integer} PartnerCompanyID
   * @default 0
   */
  exports.prototype['PartnerCompanyID'] = 0;
  /**
   * @member {Boolean} IsPartnerCompanyAdministrator
   * @default false
   */
  exports.prototype['IsPartnerCompanyAdministrator'] = false;
  /**
   * @member {Array.<module:model/SpecialMenuItem>} SpecialMenuItems
   */
  exports.prototype['SpecialMenuItems'] = undefined;
  /**
   * @member {Boolean} IsAdvisor
   * @default false
   */
  exports.prototype['IsAdvisor'] = false;
  /**
   * @member {Integer} AdvisorID
   * @default 0
   */
  exports.prototype['AdvisorID'] = 0;
  /**
   * @member {String} AdvisorName
   * @default ''
   */
  exports.prototype['AdvisorName'] = '';
  /**
   * @member {String} AdvisorLogoURI
   * @default ''
   */
  exports.prototype['AdvisorLogoURI'] = '';
  /**
   * @member {String} AdvisorPromotionalText
   * @default ''
   */
  exports.prototype['AdvisorPromotionalText'] = '';
  /**
   * @member {String} AdvisorPromotionalURI
   * @default ''
   */
  exports.prototype['AdvisorPromotionalURI'] = '';
  /**
   * @member {Boolean} CashflowForecastEnabled
   * @default false
   */
  exports.prototype['CashflowForecastEnabled'] = false;
  /**
   * @member {Boolean} Is4SCompany
   * @default false
   */
  exports.prototype['Is4SCompany'] = false;
  /**
   * @member {Integer} ProductPackageID
   * @default 0
   */
  exports.prototype['ProductPackageID'] = 0;
  /**
   * @member {Boolean} HasTemporaryAlertAccess
   * @default false
   */
  exports.prototype['HasTemporaryAlertAccess'] = false;
  /**
   * @member {Boolean} HasTemporaryWorkshopAccess
   * @default false
   */
  exports.prototype['HasTemporaryWorkshopAccess'] = false;
  /**
   * @member {Boolean} StrategyOnboardingDone
   * @default false
   */
  exports.prototype['StrategyOnboardingDone'] = false;
  /**
   * @member {Integer} StrategyExecutionTypeID
   */
  exports.prototype['StrategyExecutionTypeID'] = undefined;
  /**
   * @member {Integer} StrategyPublishingLevelID
   */
  exports.prototype['StrategyPublishingLevelID'] = undefined;
  /**
   * @member {Boolean} StrategyAllowNotAlignedBreakthrough
   * @default false
   */
  exports.prototype['StrategyAllowNotAlignedBreakthrough'] = false;
  /**
   * @member {Integer} StrategyAllowUserInviteTypeID
   */
  exports.prototype['StrategyAllowUserInviteTypeID'] = undefined;
  /**
   * @member {Boolean} PublicPagesEnabled
   * @default false
   */
  exports.prototype['PublicPagesEnabled'] = false;
  /**
   * @member {Boolean} IsPublicPageUser
   * @default false
   */
  exports.prototype['IsPublicPageUser'] = false;
  /**
   * @member {Integer} PublicPageID
   */
  exports.prototype['PublicPageID'] = undefined;
  /**
   * @member {Integer} PublicPageCreatedByUserID
   */
  exports.prototype['PublicPageCreatedByUserID'] = undefined;
  /**
   * @member {Boolean} IsStrategyFacilitator
   * @default false
   */
  exports.prototype['IsStrategyFacilitator'] = false;
  /**
   * @member {Boolean} CustomerGeneralSatisfaction
   * @default false
   */
  exports.prototype['CustomerGeneralSatisfaction'] = false;
  /**
   * @member {Integer} UserRoleBillingUserTypeID
   */
  exports.prototype['UserRoleBillingUserTypeID'] = undefined;
  /**
   * @member {Boolean} CanUserAddStrategy
   * @default false
   */
  exports.prototype['CanUserAddStrategy'] = false;
  /**
   * @member {Boolean} CompanyHasInitiatives
   * @default false
   */
  exports.prototype['CompanyHasInitiatives'] = false;
  /**
   * @member {Integer} QuickStartID
   */
  exports.prototype['QuickStartID'] = undefined;
  /**
   * @member {Date} QuickStartEndDate
   */
  exports.prototype['QuickStartEndDate'] = undefined;
  /**
   * @member {Boolean} HasMobileToken
   * @default false
   */
  exports.prototype['HasMobileToken'] = false;
  /**
   * @member {Boolean} IsTrialUnknownUser
   * @default false
   */
  exports.prototype['IsTrialUnknownUser'] = false;
  /**
   * @member {Integer} InitialStartingPoint1
   */
  exports.prototype['InitialStartingPoint1'] = undefined;
  /**
   * @member {Integer} InitialStartingPoint2
   */
  exports.prototype['InitialStartingPoint2'] = undefined;
  /**
   * @member {String} WorkshopLanguageCode
   * @default ''
   */
  exports.prototype['WorkshopLanguageCode'] = '';
  /**
   * @member {Boolean} IsExternalUser
   * @default false
   */
  exports.prototype['IsExternalUser'] = false;
  /**
   * @member {Boolean} UseUserRoleBasedBilling
   * @default false
   */
  exports.prototype['UseUserRoleBasedBilling'] = false;
  /**
   * @member {Boolean} AllowCustomTaspaExporting
   * @default false
   */
  exports.prototype['AllowCustomTaspaExporting'] = false;
  /**
   * @member {Boolean} DisableWhereby
   * @default false
   */
  exports.prototype['DisableWhereby'] = false;



  return exports;
}));


